function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M12.9 25.3c-1.5 0-2.6-1.4-2.6-3.2 0-1.8 1.2-3.2 2.6-3.2s2.6 1.4 2.6 3.2c0 1.8-1.2 3.2-2.6 3.2zm0-6.1c-1.3 0-2.4 1.3-2.4 3s1.1 2.9 2.4 2.9 2.4-1.3 2.4-2.9-1.1-3-2.4-3z" /><path d="M15.094 23.248L18.048 5.29l.296.05-2.954 17.957z" /><g><path d="M20.1 25.3c-1.5 0-2.6-1.4-2.6-3.2 0-1.8 1.2-3.2 2.6-3.2 1.5 0 2.6 1.4 2.6 3.2.1 1.8-1.1 3.2-2.6 3.2zm0-6.1c-1.3 0-2.4 1.3-2.4 3s1.1 2.9 2.4 2.9 2.4-1.3 2.4-2.9-1.1-3-2.4-3z" /><path d="M14.721 5.337l.296-.049 2.956 17.958-.296.05z" /></g></svg>;
});